import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { useContext } from 'react';
import { ContainerContext } from '../utils/ContainerContext';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Used by tech writers via Markdown backticks (\`\`) or by using the `<code />`
 * HTML element directly
 *
 * Under the hood, this renders a standard `foundations` `Text` as `code` component
 * with added `wordBreak` styling. The `wordBreak` styling is removed
 * conditionally when the parent component is a table, as the table component allows tables to
 * scroll sideways. Given that the scroll container exists here we do not need
 *  `word-break` and further do not want it as it causes too many breaks
 * in the word at mobile screen sizes.
 */
const Code = props => {
  const inTable = useContext(ContainerContext) === 'table';
  const {
      children
    } = props,
    restOfProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-tertiary-default",
    as: "span",
    children: /*#__PURE__*/_jsx(Text, Object.assign({
      as: "code",
      wordBreak: inTable ? 'normal' : 'break-all',
      textWrap: inTable ? undefined : 'wrap'
    }, restOfProps, {
      children: children
    }))
  });
};
export default Code;